import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  layout?: "grid" | "list";
}

export default function MovieCard({ movie, layout = "grid" }: MovieCardProps) {
  if (layout === "list") {
    return (
      <Link
        to={`/detail/${movie.id}`}
        className="group flex w-full gap-3 rounded-lg border border-background-200/70 bg-background-100 p-2.5 transition-colors hover:border-primary-400"
      >
        <div className="relative h-[104px] w-[72px] shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={movie.cover}
            alt={`${movie.title} 影视封面`}
            title={`${movie.title} - 黑桃视频影视详情`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <h3 className="truncate text-sm font-500 text-foreground-950 transition-colors group-hover:text-primary-400">
            {movie.title}
          </h3>
          <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{movie.summary}</p>
          <div className="mt-auto flex items-center gap-2 pt-2 text-[11px] text-foreground-500">
            <span>{movie.year}</span>
            <span className="text-background-300">·</span>
            <span>{movie.region}</span>
            <span className="ml-auto flex items-center gap-1 text-accent-500">
              <i className="ri-star-fill text-[11px]" aria-hidden="true"></i>
              {movie.rating.toFixed(1)}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-colors hover:border-primary-400"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 影视封面`}
          title={`${movie.title} - 黑桃视频影视详情`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded bg-background-950/70 px-1.5 py-0.5 text-[11px] font-500 text-accent-400 backdrop-blur">
          {movie.category}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded bg-background-950/70 px-1.5 py-0.5 text-[11px] font-500 text-accent-400 backdrop-blur">
          <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-500 text-foreground-950 transition-colors group-hover:text-primary-400">
          {movie.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">{movie.summary}</p>
        <div className="mt-2.5 flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
        <div className="mt-auto flex items-center gap-2 pt-2.5 text-[11px] text-foreground-500">
          <span>{movie.region}</span>
          <span className="text-background-300">·</span>
          <span>{movie.year}</span>
        </div>
      </div>
    </Link>
  );
}